import { createLogger } from '@/logger';

import {
  getAuthenticatedUser,
  refreshCredentials,
  userAttributesFromHash,
  attributesToHash,
} from './cognito';
import friendly from './errors';

const log = createLogger('auth.profile');

function getProfileAttributes({ attrs, success, error }) {
  const handleError = err => error(friendly(err, log));
  const resultHandler = (err, res) => {
    if (err) return handleError(err);

    const profile = attributesToHash(res);
    const out = Object.assign({}, ...attrs.map(key => ({ [key]: profile[key] })));

    log.information({
      message: attrs.reduce(
        (acc, key) => `${acc} ${key}=${out[key]}`,
        'Retrieved profile data:'),
    });

    return success(out);
  };

  getAuthenticatedUser({
    error: handleError,
    success: ({ user }) => user.getUserAttributes(resultHandler),
  });
}

function setProfileAttributes({ attrs, success, error }) {
  const handleError = err => error(friendly(err, log));

  getAuthenticatedUser({
    error: handleError,
    success: ({ user }) => {
      log.information({
        message: attrs.reduce(
          (acc, { Name, Value }) => `${acc} ${Name}=${Value}`,
          'Updating profile:'),
      });
      user.updateAttributes(attrs, (err) => {
        if (err) handleError(err);
        // fetch new tokens to avoid stale data in payload
        else refreshCredentials({ success, error: handleError });
      });
    },
  });
}


export function getUserProfile({ success, error }) {
  getProfileAttributes({
    success,
    error,
    attrs: ['email', 'given_name', 'family_name', 'email_verified'],
  });
}

export function getConsentDate(cb) {
  getAuthenticatedUser({
    success: ({ session }) => cb(session.idToken.payload['custom:consent_date']),
    error: () => cb(null),
  });
}

/**
 * Does not accept email as a property to update due to upstream
 */
export function setUserProfile({
  given_name, family_name,
  success, error,
}) {
  setProfileAttributes({
    success,
    error,
    attrs: userAttributesFromHash({ given_name, family_name }),
  });
}

export function setConsentDate({ consent_date, success, error }) {
  setProfileAttributes({
    error,
    success,
    attrs: userAttributesFromHash({ 'custom:consent_date': consent_date }),
  });
}



// WEBPACK FOOTER //
// ./src/auth/profile.js